"use client";

import React, { useCallback } from "react";
import { useLabels, useLocale } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { fetchCompetitionPosts } from "@/app/(app)/actions/fetchCompetitionPosts";
import { CompetitionPostsPageClient } from "./CompetitionPostsPageClient";
import type { Post } from "@/payload-types";

interface CompetitionNewsPageClientProps {
    initialPosts: Post[];
    totalPages: number;
    initialPage: number;
    competitionId: string;
    articlesPerPage: number;
}

export const CompetitionNewsPageClient: React.FC<CompetitionNewsPageClientProps> = ({
    initialPosts,
    totalPages,
    initialPage,
    competitionId,
    articlesPerPage,
}) => {
    const labels = useLabels();
    const locale = useLocale();
    const nav = useNavigation();

    const fetchPage = useCallback(
        (page: number) =>
            fetchCompetitionPosts({
                competitionId,
                locale,
                type: "article",
                page,
                limit: articlesPerPage,
            }),
        [competitionId, locale, articlesPerPage]
    );

    return (
        <CompetitionPostsPageClient
            initialPosts={initialPosts}
            totalPages={totalPages}
            initialPage={initialPage}
            postsPerPage={articlesPerPage}
            heading={labels.competitions.news}
            emptyMessage="No articles available for this competition yet."
            buildLink={nav.post}
            fetchPage={fetchPage}
        />
    );
};
